import { render, staticRenderFns } from "./TransferApplicationDialog.vue?vue&type=template&id=152d8a4a&scoped=true"
import script from "./TransferApplicationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferApplicationDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TransferApplicationDialog.vue?vue&type=style&index=0&id=152d8a4a&prod&lang=scss"
import style1 from "./TransferApplicationDialog.vue?vue&type=style&index=1&id=152d8a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152d8a4a",
  null
  
)

export default component.exports